import { Module } from 'vuex';
import { StateInterface } from '../index';
import state, { SettingStateInterface } from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const settingModule: Module<SettingStateInterface, StateInterface> = {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
};

export default settingModule;
